import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  useTheme,
  CircularProgress,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
import Header from "../../../components/Header";
import axios from "axios";
import { format } from "date-fns";

const EditDespesa = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [uploadProgress, setUploadProgress] = useState(0);
  const [despesaData, setDespesaData] = useState({
    nomeCliente: "",
    tipoDespesa: "",
    data: "",
    percursoCompleto: "",
    kms: "",
    valorTotal: "",
    matricula: "",
    aprovador1: "",
    aprovador2: "",
    notas: "",
    ficheiro: "", // URL do arquivo
    //ficheiro: "", // Nome do arquivo
    estado: "",
  });

  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const despesaResponse = await axios.get(
          `https://pf-auditores.ew.r.appspot.com/api/folha-despesas/${id}`
        );
        const despesaData = despesaResponse.data;
        console.log("Despesa Data:", despesaData);

        const clienteResponse = await axios.get(
          `https://pf-auditores.ew.r.appspot.com/api/clientes/${despesaData.clienteId}`
        );
        const nomeCliente = clienteResponse.data.nomeCliente;

        const aprovador1Response = await axios.get(
          `https://pf-auditores.ew.r.appspot.com/api/colaboradores/${despesaData.aprovador1}`
        );
        const aprovador2Response = await axios.get(
          `https://pf-auditores.ew.r.appspot.com/api/colaboradores/${despesaData.aprovador2}`
        );
        const aprovador1 = aprovador1Response.data;
        const aprovador2 = aprovador2Response.data;
        console.log("Aprovador 1 Nome:", aprovador1.nome);

        const ficheiro = despesaData.ficheiro
          ? despesaData.ficheiro
          : "";

        setDespesaData({
          ...despesaData,
          nomeCliente: nomeCliente,
          data: format(new Date(despesaData.data), "yyyy-MM-dd"),
          ficheiro: ficheiro,
          aprovador1: aprovador1.id,
          nomeAprovador1: aprovador1.nome,
          aprovador2: aprovador2.id,
          nomeAprovador2: aprovador2.nome,
        });

        const clientesResponse = await axios.get(`https://pf-auditores.ew.r.appspot.com/api/clientes`);
        const todosClientes = clientesResponse.data;

        const clientesAtualizados = [
          { id: despesaData.clienteId, nomeCliente: nomeCliente },
          ...todosClientes.filter((cliente) => cliente.id !== despesaData.clienteId),
        ];

        setClientes(clientesAtualizados);

        const colaboradoresResponse = await axios.get(
          `https://pf-auditores.ew.r.appspot.com/api/colaboradores`
        );
        const todosColaboradores = colaboradoresResponse.data;
        const colaboradoresExcluindoAprovadores = todosColaboradores.filter(
          (colaborador) =>
            colaborador.id !== despesaData.aprovador1 &&
            colaborador.id !== despesaData.aprovador2
        );

        setColaboradores(colaboradoresExcluindoAprovadores);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  
  const handleGuardarClick = async () => {
    setIsSaving(true);
    try {
      const updatedDespesaData = {
        ...despesaData, // Inclui todas as propriedades existentes em `despesaData`
        ficheiro: `https://storage.cloud.google.com/pf-auditores.appspot.com/${despesaData.ficheiro}`, // Atualiza a URL do ficheiro
        data: format(new Date(despesaData.data), "yyyy-MM-dd"), // Formata a data para enviar para o backend
      };

      console.log("Dados antes de enviar para o backend:", updatedDespesaData);

      // Realiza o upload do arquivo, se existir e se for um novo arquivo
      if (despesaData.ficheiro instanceof File) {
        const formData = new FormData();
        formData.append("file", despesaData.ficheiro);
        try {
          const response = await axios.post(
            `https://pf-auditores.ew.r.appspot.com/api/upload`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              onUploadProgress: (progressEvent) => {
                const progress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                setUploadProgress(progress); // Atualiza o progresso do upload
              },
            }
          );

          // Atribui a URL do arquivo ao objeto de dados atualizado
          updatedDespesaData.ficheiro = response.data.fileUrl;
          updatedDespesaData.ficheiro = despesaData.ficheiro.name; // Adiciona o nome do arquivo como um novo campo
        } catch (uploadError) {
          alert(
            "Erro ao fazer upload do arquivo. Por favor, verifique o tipo de arquivo e tamanho e tente novamente."
          );
          throw uploadError; // Lança o erro novamente para que seja tratado no catch externo
        }
      }

      // Atualiza a despesa no backend
      const responseUpdate = await axios.put(
        `https://pf-auditores.ew.r.appspot.com/api/folha-despesas/${id}`,
        updatedDespesaData
      );
      console.log("Resposta da API de atualização:", responseUpdate.data);

      navigate("/despesas");
    } catch (error) {
      console.error(
        "Erro ao atualizar a despesa:",
        error.response ? error.response.data : error.message
      );
    } finally {
      setIsSaving(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "valorTotal") {
      const formattedValue = new Intl.NumberFormat("pt-PT", {
        style: "currency",
        currency: "EUR",
      }).format(value);
      setDespesaData({
        ...despesaData,
        [name]: formattedValue,
      });
    } else {
      setDespesaData({
        ...despesaData,
        [name]: value,
      });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is different from the current file
      setDespesaData({
        ...despesaData,
        ficheiro: file,
        ficheiro: file.name,
      });
      setUploadProgress(0); // Reset progress on new file selection
    }
  };

  const handleRemoveFile = () => {
    setDespesaData({
      ...despesaData,
      ficheiro: "",
      ficheiro: "",
    });
  };

  if (isLoading) {
    return (
      <Box m="20px">
        <Header title="Editar Despesa" subtitle="Edite os detalhes da despesa" />
        <Box
          sx={{
            display: "grid",
            gap: "20px",
            backgroundColor: colors.primary[400],
            padding: "20px",
            borderRadius: "8px",
            gridTemplateColumns: "repeat(3, 1fr)",
          }}
        >
          <Box gridColumn="span 3" display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box m="20px">
      <Header title="Editar Despesa" subtitle="Edite os detalhes da despesa" />
      <form onSubmit={(e) => { e.preventDefault(); handleGuardarClick(); }}>
        <Box
          sx={{
            display: "grid",
            gap: "20px",
            backgroundColor: colors.primary[400],
            padding: "20px",
            borderRadius: "8px",
            gridTemplateColumns: "repeat(3, 1fr)",
          }}
        >
          <TextField
            fullWidth
            variant="filled"
            select
            label="Cliente"
            name="clienteId"
            value={despesaData.clienteId}
            onChange={handleChange}
            sx={{ gridColumn: "span 1" }}
          >
            {clientes.map((cliente, index) => (
              <MenuItem key={index} value={cliente.id}>
                {cliente.nomeCliente}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            variant="filled"
            label="Aprovador 1"
            name="aprovador1"
            disabled
            value={despesaData.nomeAprovador1}
            onChange={handleChange}
            sx={{ gridColumn: "span 1" }}
          />
          <TextField
            fullWidth
            variant="filled"
            label="Aprovador 2"
            name="aprovador2"
            disabled
            value={despesaData.nomeAprovador2}
            onChange={handleChange}
            sx={{ gridColumn: "span 1" }}
          />
          <TextField
            fullWidth
            variant="filled"
            select
            label="Tipo de Despesa"
            name="tipoDespesa"
            value={despesaData.tipoDespesa}
            onChange={handleChange}
            sx={{ gridColumn: "span 1" }}
          >
            {[
              "Deslocação em viatura própria",
              "Refeições",
              "Outras despesas",
            ].map((tipoDespesa, index) => (
              <MenuItem key={index} value={tipoDespesa}>
                {tipoDespesa}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            variant="filled"
            type="date"
            label="Data"
            name="data"
            value={despesaData.data}
            disabled
            sx={{ gridColumn: "span 1" }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Percurso Completo"
            name="percursoCompleto"
            value={despesaData.percursoCompleto}
            onChange={handleChange}
            sx={{ gridColumn: "span 1" }}
          />
          <TextField
            fullWidth
            variant="filled"
            type="number"
            label="Kms"
            name="kms"
            value={despesaData.kms}
            onChange={handleChange}
            sx={{ gridColumn: "span 1" }}
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Valor Total"
            name="valorTotal"
            value={despesaData.valorTotal}
            onChange={handleChange}
            sx={{ gridColumn: "span 1" }}
            InputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Matricula do Veículo"
            name="matricula"
            value={despesaData.matricula}
            onChange={handleChange}
            sx={{ gridColumn: "span 1" }}
          />
          <TextField
            fullWidth
            variant="filled"
            select
            label="Estado"
            name="estado"
            value={despesaData.estado}
            onChange={handleChange}
            sx={{ gridColumn: "span 1" }}
          >
            {["Aprovado", "Rejeitado", "Pendente"].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Notas"
            name="notas"
            value={despesaData.notas}
            onChange={handleChange}
            sx={{ gridColumn: "span 2" }}
          />
          <Box
            fullWidth
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ gridColumn: "span 3" }}
          >
            <input
              type="file"
              accept=".pdf,.png,.jpeg"
              id="upload-file"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <label htmlFor="upload-file">
              <Button variant="contained" component="span">
                Carregar Ficheiro
              </Button>
            </label>
            {despesaData.ficheiro && (
              <>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleRemoveFile}
                >
                  Remover
                </Button>
                {uploadProgress > 0 && (
                  <CircularProgress
                    variant="determinate"
                    value={uploadProgress}
                    color="success"
                  />
                )}
                <span>{despesaData.ficheiro}</span>
              </>
            )}
            <span>
              <b>Limite de upload: </b>10MB
            </span>
          </Box>
        </Box>
        <Box mt="20px" display="flex" justifyContent="space-between" alignItems="center">
          <Button variant="contained" color="primary" onClick={() => navigate("/despesas")}>
            Voltar
          </Button>
          <Button variant="contained" color="secondary" type="submit" disabled={isSaving}>
            {isSaving ? <CircularProgress size={24} /> : "Guardar"}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default EditDespesa;
